import config from 'src/config'
import store from 'src/store'
import Cookies from 'js-cookie'
import router from 'src/router'
import { FiltradorDeErros } from 'src/erros'
import deslogarQuandoTokenExpirar from 'src/typescript/servicos/http/interceptadores/deslogarQuandoExpirar.ts'
import capturarErros from 'src/typescript/servicos/http/interceptadores/capturarErros.ts'
import { listarFaturas, notificacaoSobreVencimento } from 'src/typescript/modulos/tiosam/faturas/servico/faturas.servico'
import i18n from 'src/typescript/servicos/i18n/i18n.servico'
import { legacyHttp, legacyResource } from 'src/legacy/http'
import { emitCheckUserFiles } from 'src/events/notifications'
import { Notification } from 'src/common/uiv/notification'
import { modalDeErro, modalDeSucesso } from 'src/utils'

// Migration stuff
import { hasPermission } from 'src/utils'

import { requisitarComMultiplasTentativas } from 'src/utils/executoras/executoras'

// Exporte a função requisitarComMultiplasTentativas como retryRequest
// TODO: renomear os imports nos arquivos para a função com nome em português
export { requisitarComMultiplasTentativas as retryRequest }

const EndPoint = config.baseUrl + '/api/'

const EndPointIntegracao = `${config.integracaoUrl}` + '/'

const EndPointGerenciadorDeColetores = config.gerenciadorDeColetoresUrl + '/'

const EndPointKeycloak = config.keycloakBaseUrl + '/'

export const EndPointArquivosDeImportadores = EndPoint + 'obter-arquivo-importador'
const EndPointImportadoresGestao = EndPoint + 'importadores-gestao-web'

// const EndPointRepp = config.reppUrl + '/'

/**
 * Atenção: Cuidado ao adicionar uma nova API neste array,
 * como fazemos um .includes, pode ocorrer de uma string adicionada
 * coincida com outra url que precisa de autenticação.
 * Tente deixar o nome da API o mais específico possível.
 */
const ApisQueNaoPrecisamDeAutenticacao = [
  '/ambientes-do-usuario/'
]

let globalLegacyHttpInterceptorsRegistered = false

export const registerGlobalLegacyHttpInterceptors = () => {
  if (globalLegacyHttpInterceptorsRegistered) {
    return
  }

  globalLegacyHttpInterceptorsRegistered = true

  legacyHttp.interceptors.push(function (request, next) {
    if (window.location.href.includes('/login')) {
      next()
    }

    if (store.getters.usuarioEstaAutenticado) {
      request.headers.set('x-perfil-acesso', store.state.perfilDeAcessoSelecionadoParaMultiPerfis)
    }

    // Se a URL da requisição contém alguma das APIs que não precisam de autenticação, não adiciona o token
    if (ApisQueNaoPrecisamDeAutenticacao.some(api => request.url.includes(api))) {
      next()
      return
    }

    if (!request.url.endsWith('oauth2/token')) {
      // SUPER IMPORTANT STEP HERE
      // the ...oauth2/token is used to get the togens from cognito of a user that
      // is logged using SAML. This API doesnt like to receive not expected headers

      if (store.state.auth && !!store.state.auth.authorization) {
        request.headers.set('Authorization', store.state.auth.authorization)
      } else {
        request.headers.set('Authorization', Cookies.get('Authorization'))
      }

      if (store.state.auth.accessToken || Cookies.get('accessToken')) {
        request.headers.set('X-PontoTel-Authorization', store.state.auth.accessToken || Cookies.get('accessToken'))
        request.headers.set('X-PontoTel-UP', store.state.auth.userPoolId || Cookies.get('userPoolId'))
        request.headers.set('X-PontoTel-DI', store.state.auth.userPoolWebClientId || Cookies.get('userPoolWebClientId'))
      }
    }

    if (request.url.endsWith('/auth') || request.url.includes('salvar-log-usuario-logou')) {
      request.headers.set('x-pontotel-dispositivo', 'web')
    }

    if (request.url.includes('http://localhost:8000')) {
      request.headers.set('CMP', store.state.userInfo.compMan.id)
    }

    const idiomaI18n = localStorage.getItem('idioma')
    if (idiomaI18n) {
      request.headers.set('Accept-Language', idiomaI18n)
    }

    next()
  })

  legacyHttp.interceptors.push(_ => {
    return response => {
      if (response.status === 403) {
        const respostaEmString = response.data ? JSON.stringify(response.data) : ''
        const erro403Nginx = respostaEmString.includes('nginx') && respostaEmString.includes('403 Forbidden')
        if (erro403Nginx) {
          router.push('/acesso-negado')
        }
      }
    }
  })

  legacyHttp.interceptors.push(deslogarQuandoTokenExpirar)
  legacyHttp.interceptors.push(capturarErros)
}

export async function gerarComprovanteDoPonto(pontoId, link) {
  const headers = new Headers()
  let token = Cookies.get('Authorization')

  if (store.state.auth && !!store.state.auth.authorization) {
    token = store.state.auth.authorization
  }

  if (store.state.auth.accessToken || Cookies.get('accessToken')) {
    token = store.state.auth.accessToken || Cookies.get('accessToken')
  }

  headers.append('Authorization', token)

  try {
    const response = await fetch(`${EndPoint}gerar-comprovante-da-marcacao/${pontoId}`, { headers })
    if (response.status !== 200) return

    const blob = await response.blob()
    const objUrl = window.URL.createObjectURL(blob)

    link.href = objUrl
    link.download = `comprovante_do_ponto_${pontoId}.pdf`
    link.click()

    URL.revokeObjectURL(objUrl)
  } catch (erro) {
    FiltradorDeErros.capturarErro(erro)
  }
}

export async function gerarRelatorioDeColetores(link, filtros) {
  const headers = new Headers()
  let token = Cookies.get('Authorization')
  let url = `${EndPointGerenciadorDeColetores}coletores/relatorio`

  if (filtros) {
    url += `?${filtros}`
  }

  if (store.state.auth && !!store.state.auth.authorization) {
    token = store.state.auth.authorization
  }

  if (store.state.auth.accessToken || Cookies.get('accessToken')) {
    token = store.state.auth.accessToken || Cookies.get('accessToken')
  }

  headers.append('Authorization', token)

  fetch(url, { headers })
    .then(response => {
      if (response.status === 200) {
        modalDeSucesso('Relatório sendo gerado... Por favor, aguarde.')
        response.blob().then(blob => {
          const objUrl = window.URL.createObjectURL(blob)

          link.href = objUrl
          link.download = 'relatorio_de_coletores.xlsx'
          link.click()

          URL.revokeObjectURL(objUrl)
        })
      } else {
        modalDeErro('Erro ao gerar o relatório.')
      }
    })
    .catch(() => {
      FiltradorDeErros.capturarErroDandoFeedback(new Error('Erro ao gerar o relatório de coletores'), () => {
        modalDeErro('Erro ao gerar o relatório.')
      })
    })
}

export const API = {
  login: legacyResource(EndPoint + 'auth'),

  info: legacyResource(EndPoint + 'personal/short'),

  sincronizarEmpregadoRepp: legacyResource(EndPoint + 'employee-sincronizar-com-repp{/empregadoId}'),

  sincronizarLocalRepp: legacyResource(EndPoint + 'company-sincronizar-com-repp{/localId}'),

  sincronizarEmpregadorRepp: legacyResource(EndPoint + 'employer-sincronizar-com-repp{/empregadorId}'),

  notification: legacyResource(EndPoint + 'notification'),

  forgotPassword: legacyResource(EndPoint + 'esqueci-minha-senha{/email}{/recaptcha}'),

  applyAll: legacyResource(EndPoint + 'apply-all'),

  holiday: legacyResource(EndPoint + 'holiday-calendar{/id}'),

  frontVisual: legacyResource(EndPoint + 'custom-visual{/userId}'), // -> api that returns the styles and layout

  logout: legacyResource(EndPoint + 'auth-logout'),

  userFirebaseToken: legacyResource(EndPoint + 'user/firebase-token{/entity}{/id}'),

  redirectSSORoute: legacyResource(EndPoint + 'redirect-sso-route{/compManId}'), // -> returns route for logout

  getAuthUserPool: legacyResource(EndPoint + 'auth-user-pool/frontend'),

  compManAcceptTerms: legacyResource(EndPoint + 'accept-terms{/compManId}'),

  compManDetail: legacyResource(EndPoint + 'compman-detail{/compManId}{?fields}'),

  legacyLogout: legacyResource(EndPoint + 'logout'),

  employee: legacyResource(EndPoint + 'employee{/id}'),

  approvals: legacyResource(EndPoint + 'getallapprovals'),

  solicitacaoDeAprovacao: legacyResource(EndPoint + 'solicitacao-de-aprovacao{/id}', {}, { patch: { method: 'PATCH' } }),

  gestaoDeFerias: legacyResource(EndPoint + 'gestao-de-ferias{/id}{/tipo}/'),

  solicitacoesEmMassa: legacyResource(EndPoint + 'solicitacoes-em-massa'),

  configuracaoDeSolicitacao: legacyResource(EndPoint + 'configuracoes-de-solicitacao/{configuracaoId}'),

  approvalsRules: legacyResource(EndPoint + 'getallapprovalsrules{/id}'),

  objectsApprovalRules: legacyResource(EndPoint + 'objectapprovalrules'),

  regrasDeAprovacao: legacyResource(EndPoint + 'regra-de-aprovacao{/id}', {}, { patch: { method: 'PATCH' } }),

  approveLines: legacyResource(EndPoint + 'approvalapproval'),

  transferenciaDeApontamento: legacyResource(EndPoint + 'apontamentos-para-transferencia{/empregado}{/dia}', {}),

  approvalsReport: legacyResource(EndPoint + 'relatorio/gerar-r31'),

  holidaysReport: legacyResource(EndPoint + 'holidays-report'),

  routineReport: legacyResource(EndPoint + 'routines-report'),

  journeyReport: legacyResource(EndPoint + 'journeys-report'),

  groupReport: legacyResource(EndPoint + 'groups-report'),

  employerReport: legacyResource(EndPoint + 'employers-report'),

  company: legacyResource(EndPoint + 'company{/id}'),

  companiesReport: legacyResource(EndPoint + 'companies-report'),

  journey: legacyResource(EndPoint + 'journey{/id}'),

  routine: legacyResource(EndPoint + 'routine{/id}'),

  employer: legacyResource(EndPoint + 'employer{/id}'),

  user: legacyResource(EndPoint + 'user{/id}'),

  userPerfil: legacyResource(EndPoint + 'usuarios-perfil{/perfil}'),

  userGroup: legacyResource(EndPoint + 'user-group{/id}'),

  fastRegister: legacyResource(EndPoint + 'fast-register'),

  customRules: legacyResource(EndPoint + 'custom{/id}'),

  cloneCustomRules: legacyResource(EndPoint + 'clone-custom-rules{/id}'),

  whbRules: legacyResource(EndPoint + 'work-hours-bank-rules{/id}'),

  whbRulesSave: legacyResource(EndPoint + 'regra-de-banco-de-horas{/id}'),

  preverVencimentoUnificado: legacyResource(EndPoint + 'regra-de-banco-de-horas/prever-vencimento'),

  sumtime: legacyResource(EndPoint + 'sumtime{/id}{/year}{/month}'),

  apontamentosMensais: legacyResource(EndPoint + 'apontamentos-mensais{/idDoEmpregado}'),

  apontamentosDeBancoDeHoras: legacyResource(EndPoint + 'apontamentos-mensais-gestao-banco-de-horas'),

  apontamentosDiarios: legacyResource(EndPoint + 'apontamentos-diarios'),

  arbssumtime: legacyResource(EndPoint + 'sumarbtms{/id}{/year}{/month}'),

  expectedCalcs: legacyResource(EndPoint + 'expected-calcs{/id}{/calcId}'),

  timesheet: legacyResource(EndPoint + 'timesheet-partial{/load}'),

  timesheetGeneric: legacyResource(EndPoint + 'timesheet-partial-generic'),

  timesheetPtInfo: legacyResource(EndPoint + 'timesheet-partial-pt-info{/kind}{/id}'),

  groupComment: legacyResource(EndPoint + 'todo-comment{/id}'),

  timesheetSync: legacyResource(EndPoint + 'timesheet-partial-sync'),

  fakeTimelog: legacyResource(EndPoint + 'fake-pt{/id}'),

  ignoreTimelog: legacyResource(EndPoint + 'ignore-fake-pt{/id}'),

  line: legacyResource(EndPoint + 'line{/id}'),

  lineJoin: legacyResource(EndPoint + 'linejoiner'),

  reasons: legacyResource(EndPoint + 'reason{/id}'),

  roleGroup: legacyResource(EndPoint + 'rolegroup{/id}'),

  roleDetails: legacyResource(EndPoint + 'role/details'),

  abstractJustify: legacyResource(EndPoint + 'abstract-justify{/employeeId}{/typeId}{/year}{/month}{/day}'),

  abstractJustifyById: legacyResource(EndPoint + 'abstract-justify{/employeeId}{/typeId}{/idDaDispensa}'),

  gerarUrlPreAssinadaDeArquivoParaDownload: legacyResource(EndPoint + 'gerar-url-assinada-para-download-de-arquivo-do-bucket'),

  reason: legacyResource(EndPoint + 'reason{/id}'),

  region: legacyResource(EndPoint + 'region'),

  changeMultipleDayjourney: legacyResource(EndPoint + 'change-multiple-dayjourney'),

  dashboardExtraTime: legacyResource(EndPoint + 'dashboard-extra-time'),

  dashboardSpecial: legacyResource(EndPoint + 'dashboard-special'),

  dashboardWHB: legacyResource(EndPoint + 'dashboard-whb'),

  twoWayLocker: legacyResource(EndPoint + 'two-way-locker{/month}{/year}'),

  estatisticaDiariaDeAusensiaEsperada: legacyResource(EndPoint + 'dayjourney-statistics-absence-expected{/comp_man}{/user}'),

  estatisticaDiariaInesperada: legacyResource(EndPoint + 'dayjourney-statistics-unexpected{/comp_man}{/user}'),

  estatisticaDeBloqueio: legacyResource(EndPoint + 'locker-statistics{/comp_man}{/user}'),

  twoWayLockerNotifications: legacyResource(EndPoint + 'two-way-locker/notifications'),

  unilateralLocker: legacyResource(EndPoint + 'locker/unilateral'),

  unlocker: legacyResource(EndPoint + 'unlocker'),

  forcarDestravamento: legacyResource(EndPoint + 'destravar-folha'),

  twoWayLockerGetData: legacyResource(EndPoint + 'two-way-locker/get-data{/month}{/year}'),

  twoWayLockerGetDataPage: legacyResource(EndPoint + 'two-way-locker/get-data-page{/month}{/year}'),

  twoWayLockerGetEmployees: legacyResource(EndPoint + 'two-way-locker/get-employees{/month}{/year}'),

  twoWayLockerConfirmation: legacyResource(EndPoint + 'two-way-locker-confirmation'),

  audit: legacyResource(EndPoint + 'audit{/kind}{/id}'),

  folha: legacyResource(EndPoint.replace('/api', '') + 'mostra-folha{/employeeId}{/companyId}{/year}{/month}{/just}{/showWorkHoursBank}{/showComments}'),

  folhaWHB: legacyResource(EndPoint.replace('/api', '') + 'mostra-folha-whb{/employeeId}{/companyId}{/year}{/month}{/just}/true'),

  whboCreate: legacyResource(EndPoint + 'whbo{/kind}{/id}'),

  whboManager: legacyResource(EndPoint + 'whb-manager{/kind}{/employeeId}{/startDate}{/endDate}'),

  whbCloser: legacyResource(EndPoint + 'whb-closer{/id}{/employeeId}{/date}{/dateBalance}'),

  baixaAutomatica: legacyResource(EndPoint + 'agendar-baixas{/empregado_id}'),

  whboAuth: legacyResource(EndPoint + 'whb-auth{/whobId}{/approve}'),

  conversaoDeApontamentoEmBh: legacyResource(EndPoint + 'whbapprovalrequest'),

  biometric: legacyResource(EndPoint + 'biometric/management'),

  aprovacaoBiometrias: legacyResource(EndPoint + 'biometric/aprovacao'),

  biometriaFacialFotosRecentes: legacyResource(EndPoint + 'biometric/fotos-recentes{/empregado_id}'),

  ocultarFotosRecentes: legacyResource(EndPoint + 'biometric/management/delete'),

  biometricImport: legacyResource(EndPoint + 'biometric/import{/employee_id}'),

  removerBiometria: legacyResource(EndPoint + 'biometric/fotos-recentes/delete/{/marcacao_id}'),

  cids: legacyResource(EndPoint + 'cids'),

  arbitraryTms: legacyResource(EndPoint + 'arbtms{/id}'),

  arbitraryApprove: legacyResource(EndPoint + 'arbtmsapprove'),

  arbitraryTmsNames: legacyResource(EndPoint + 'arbtmsnames{/lineId}{/dayJourneyId}{/employeeId}'),

  deviceManage: legacyResource(EndPoint + 'management-comp-man'),

  approveDevices: legacyResource(EndPoint + 'approve-devices'),

  devices: legacyResource(EndPoint + 'devices'),

  closedPeriod: legacyResource(EndPoint + 'closed-period{/id}{/month}{/year}'),

  workSchedule: legacyResource(EndPoint + 'work-scheduler{/type}'),

  // Cobre criar/cancelar/historico via o token {action}
  escalaTemporaria: legacyResource(EndPoint + 'escala-temporaria{/id}{/action}'),

  escalaTemporariaAtiva: legacyResource(EndPoint + 'escala-temporaria/empregado{/id}/ativa'),

  // Lançamento em massa migrado para o app FastAPI interno (servidor_fastapi, base
  // baseFastApiUrl), contexto calendario-de-trabalho, sem /api. O Flask :5000 não expõe mais.
  escalaTemporariaCriacaoEmMassa: legacyResource(
    config.baseFastApiUrl + '/calendario-de-trabalho/escala-temporaria/criacao-em-massa',
    {},
    {
      save: { method: 'POST' }
    }
  ),

  genEmpsDjs: legacyResource(EndPoint + 'generate-employee-dayjourneys'),

  workScheduleReport: legacyResource(EndPoint + 'work-scheduler-report'),

  authBlockUser: legacyResource(EndPoint + 'block-user'),

  authUsersSessions: legacyResource(EndPoint + 'auth-users-sessions'),

  authIpsBlackList: legacyResource(EndPoint + 'auth-ips-blacklist{/kind}'),

  authSecurityEvents: legacyResource(EndPoint + 'auth-security-events'),

  authCognitoForgotPassword: legacyResource(EndPoint + 'auth-cognito-forgot-password'),

  confirmMigrationUserCognito: legacyResource(EndPoint + 'auth-confirm-migration-user-cognito'),

  regrasDeNotificacao: legacyResource(EndPoint + 'regras-de-notificacao{/id}'),

  editarRegrasDeNotificacao: legacyResource(EndPoint + 'regras-de-notificacao{/id}', {}, { patch: { method: 'PATCH' } }),

  regraDeTravamento: legacyResource(EndPoint + 'regra-de-travamento{/id}'),

  configuracaoEmailTravamento: legacyResource(
    config.baseFastApiUrl + '/configuracao-email-travamento{/usuario_id}',
    {},
    {
      updateBatch: { method: 'PUT' }
    }
  ),

  atualizarRegraDeTravamento: legacyResource(EndPoint + 'regra-de-travamento{/id}', {}, { patch: { method: 'PATCH' } }),

  listarCategoriasDeAprovacao: legacyResource(EndPoint + 'listar-categorias-de-aprovacao'),

  notificationTypes: legacyResource(EndPoint + 'notification-types'),

  notificationTypesEmployee: legacyResource(EndPoint + 'notification-types-employee'),

  clearUserFile: legacyResource(config.baseUrl + '/clear-user-file{/compManId}{/userId}'),

  reports: legacyResource(EndPoint + 'user-file'),

  filaRelatorioTravamento: legacyResource(EndPoint + 'user-file-travamento'),

  sobreavisos: legacyResource(
    config.baseFastApiUrl + '/calendario-de-trabalho/sobreavisos/{id}',
    {},
    {
      get: { method: 'GET' },
      delete: { method: 'DELETE' }
    }
  ),

  sobreAvisoFolhaGet: legacyResource(
    config.baseFastApiUrl + '/calendario-de-trabalho/sobreavisos/folha{/id_jornada_do_dia}',
    {},
    {
      get: { method: 'GET' },
    }
  ),

  sobreAvisoFolha: legacyResource(
    config.baseFastApiUrl + '/calendario-de-trabalho/sobreavisos/folha{/id_empregado}{/id_jonada_do_dia}{/dia_especifico}',
    {},
    {
      save: { method: 'POST' },
      delete: { method: 'DELETE' }
    }
  ),

  editTimelog: legacyResource(EndPoint + 'edittimelog'),

  recalculateKind: legacyResource(EndPoint + 'recalculatekind'),

  generateDeviceReport: legacyResource(config.baseUrl + '/generate-status-report'),

  whbWindowManagement: legacyResource(EndPoint + 'whb-window-management{/employeeId}'),

  whbRulesManagement: legacyResource(EndPoint + 'work-hours-bank-rules-all'),

  whbCount: legacyResource(EndPoint + 'whb-count'),

  timesheetVerify: legacyResource(EndPoint + 'timesheet-verify'),

  usersReport: legacyResource(EndPoint + 'relatorio/gerar-planilha-de-usuarios'),

  autoComplete: legacyResource(EndPoint + 'relatorio/gerar-relatorio-de-autocompletar'),

  correcaoAutomaticaDeMarcacoes: legacyResource(EndPoint + 'relatorio/gerar-correcao-automatica-de-marcacoes'),

  correcaoAutomaticaCorrigir: legacyResource(config.baseFastApiUrl + '/registros/correcoes/corrigir'),

  correcaoAutomaticaDesfazer: legacyResource(config.baseFastApiUrl + '/registros/correcoes/desfazer'),

  afastamento: legacyResource(EndPoint + 'workjourney_folga{/employeeId}{/startDate}{/endDate}{/creatorId}{/journeyId}'),

  editarAfastamento: legacyResource(EndPoint + 'workjourney_folga/set_end{/employeeId}{/endDate}{/creatorId}'),

  vacation: legacyResource(EndPoint + 'vacation{/employeeId}{/startDate}{/endDate}'),

  authTerms: legacyResource(EndPoint.replace('/api', '') + 'auth-terms{/date}{/employeeId}'),

  reasonReport: legacyResource(EndPoint + 'reason-report'),


  gerenciamentoDeArquivos: legacyResource(EndPoint + 'aprovacao_de_arquivo{/id}'),

  aprovacaoIndividualDeArquivo: legacyResource(EndPoint + 'aprovacao-individual{/id}{/acoes}'),

  trabalhoRemoto: legacyResource(EndPoint + 'trabalho-remoto'),
  demitirEmpregado: legacyResource(EndPoint + 'demitir-empregado'),

  readmitirEmpregado: legacyResource(EndPoint + 'readmitir-empregado'),

  janelaDiaria: legacyResource(EndPoint + 'janela-diaria{/idFuncionario}{/diaInicial}{/diaFinal}'),

  controleDeAcesso: legacyResource(EndPoint + 'controle-de-acesso/cidr{/id}', {}, { patch: { method: 'PATCH' } }),

  gerenciarListaDeAcesso: legacyResource(EndPoint + 'controle-de-acesso/gerenciar-listas-de-acesso'),

  informacoesDeUsuario: legacyResource(EndPoint + 'user-info'),

  gerarEEnviarQrCodeEmail: legacyResource(EndPoint + 'relatorio/gerar-relatorio-de-qrcode'),

  logDeOperacoes: legacyResource(EndPoint + 'audit-log'),

  rubricas: legacyResource(EndPoint + 'rubricas{/id}'),

  arquivarRubrica: legacyResource(EndPoint + 'rubricas/arquivar{/id}', {}, { patch: { method: 'PATCH' } }),

  grupoDeRubrica: legacyResource(EndPoint + 'grupos-rubricas{/id}'),

  arquivarGrupoDeRubrica: legacyResource(EndPoint + 'grupos-rubricas/arquivar{/id}', {}, { patch: { method: 'PATCH' } }),

  credenciaisMensageriaFirebase: legacyResource(EndPoint + 'credenciais-firebase'),

  listagemDeApontamentos: legacyResource(EndPoint + 'folhas-apontamentos-api'),

  acompanhamento: legacyResource(EndPoint + 'acompanhamento/horarios-previstos{/id}'),

  historicoPonto: legacyResource(EndPoint + 'historico-ponto'),

  historicoPontoMes: legacyResource(EndPoint + 'historico-ponto-mes'),

  historicoPontoDia: legacyResource(EndPoint + 'historico-ponto-dia'),

  customizacaoModuloDeTravamento: legacyResource(EndPoint + 'customizar-modulo-de-travamento'),

  // ParametrizadorE02
  verbas: legacyResource(EndPoint + 'recursos-para-parametrizacao'),

  parametrizador: legacyResource(EndPoint + 'parametrizacao'),

  // Coletores
  aprovarColetor: legacyResource(EndPointGerenciadorDeColetores + 'coletor{/id}/aprovar'),
  reprovarColetor: legacyResource(EndPointGerenciadorDeColetores + 'coletor{/id}/reprovar'),
  aprovarTodosColetores: legacyResource(EndPointGerenciadorDeColetores + 'coletores/aprovar-pendentes'),
  coletor: legacyResource(EndPointGerenciadorDeColetores + 'coletor{/id}'),
  coletores: legacyResource(EndPointGerenciadorDeColetores + 'coletores'),
  relatorioColetores: legacyResource(EndPointGerenciadorDeColetores + 'coletores/relatorio'),
  urlsDeRedirecionamento: legacyResource(EndPointGerenciadorDeColetores + 'urls-de-redirecionamento/gestao'),

  // Perfil
  perfis: legacyResource(EndPointGerenciadorDeColetores + 'perfis-de-coletor'),
  perfil: legacyResource(EndPointGerenciadorDeColetores + 'perfil-de-coletor{/id}'),
  definirPerfilPadrao: legacyResource(EndPointGerenciadorDeColetores + 'perfil-de-coletor{/id}/definir-como-padrao'),
  chavesDeInstalacao: legacyResource(EndPointGerenciadorDeColetores + 'chaves-de-instalacao'),
  revogarChaveDeInstalacao: legacyResource(EndPointGerenciadorDeColetores + 'chaves-de-instalacao/revogar'),

  tioSam: {
    /** @typedef {import('./typescript/modulos/tiosam/faturas/dominio/faturas.interface').Fatura} Fatura */
    /**
     * @typedef {import('./typescript/modulos/tiosam/faturas/dominio/faturas.interface').NotificacaoSobreVencimentoDeFatura} NotificacaoSobreVencimentoDeFatura */

    /** @returns {Promise<Fatura[]>} */
    faturas: async () => {
      const compManId = store.state?.userInfo?.compMan?.id;

      if (compManId) return await listarFaturas(compManId);

      return [];
    },

    /**
     * @param {{ compManId?: string, faturas: Fatura[] | null }}
     * @returns {Promise<NotificacaoSobreVencimentoDeFatura?>}
     */
    notificacaoSobreVencimento: async ({ compManId, faturas = null }) => {
      if (!compManId) return null;

      if (faturas === null) {
        faturas = await listarFaturas(compManId);
      }

      return await notificacaoSobreVencimento(faturas, {
        t: (key) => i18n.t(key).toString(),
      });
    },
  },

  criarGerenciamentoDeArquivo: async (parametros) => {
    const {
      descricao, dataLimitePedidoUtc, arquivo,
      categoriaId, acoesDeNotificacao,
      mensagemCustomizada, usuariosQueAprovarao,
      usuarioVinculado
    } = parametros

    const formData = new FormData()
    formData.append('descricao', descricao)
    formData.append('data_limite_pedido_utc', dataLimitePedidoUtc)
    formData.append('motivo_padrao_id', categoriaId)
    formData.append('acoes_de_notificacao', acoesDeNotificacao)
    formData.append('usuarios_que_aprovarao', usuariosQueAprovarao)
    formData.append('usuario_vinculado', usuarioVinculado)
    formData.append('arquivo_vindo_do_front', arquivo)
    formData.append('mensagem_customizada', mensagemCustomizada)

    const result = await legacyResource(`${EndPoint}aprovacao_de_arquivo`).save(formData)
    return result
  },

  R01: legacyResource(EndPoint.replace('/api', '') + 'comp_man_timelogsheet'),

  BetaR01: legacyResource(EndPoint + 'relatorio/gerar-r01'),

  R02: legacyResource(EndPoint + 'relatorio/gerar-r02'),

  BetaR03: legacyResource(EndPoint + 'relatorio/gerar-r03'),

  R05: legacyResource(EndPoint.replace('/api', '') + 'export_default_apontamento_excel_compman'),

  BetaR05: legacyResource(EndPoint + 'relatorio/gerar-r05'),

  R06: legacyResource(EndPoint + 'generate-custom-report{/regraDeCalculoId}'),

  BetaR06: legacyResource(EndPoint + 'relatorio/gerar-r06'),

  R08: legacyResource(EndPoint + 'reportpdf{/startDate}{/endDate}'),

  R09: legacyResource(EndPoint + 'generate-timelogs-xls-report'),

  BetaR09: legacyResource(EndPoint + 'relatorio/gerar-r09'),

  R10: legacyResource(EndPoint + 'generate-whb-report'),

  BetaR10: legacyResource(EndPoint + 'relatorio/gerar-r10'),

  R12: legacyResource(EndPoint + 'report-punched{/reportType}'),

  BetaR13: legacyResource(EndPoint + 'relatorio/gerar-r13'),

  R14: legacyResource(EndPoint + 'generate-transfer-xls-report'),

  R15: legacyResource(EndPoint + 'changes-report'),

  R16: legacyResource(EndPoint + 'relatorio/gerar-r16'),

  R17: legacyResource(EndPoint + 'workjourney-folga-report'),

  BetaR17: legacyResource(EndPoint + 'relatorio/gerar-r17'),

  R18: legacyResource(EndPoint + 'benefits-report'),

  BetaR18: legacyResource(EndPoint + 'relatorio/gerar-r18'),

  R19: legacyResource(EndPoint + 'relatorio/gerar-r19'),

  R20: legacyResource(EndPoint + 'relatorio/gerar-r20'),

  R21: legacyResource(EndPoint + 'approve-whb-report'),

  R21Afya: legacyResource(EndPoint + 'gerar-r21-afya'),

  BetaR21: legacyResource(EndPoint + 'relatorio/gerar-r21'),

  R22: legacyResource(EndPoint + 'ver-folhas-report'),

  BetaR22: legacyResource(EndPoint + 'relatorio/gerar-r22'),

  R23: legacyResource(EndPoint + 'activity-lines-report'),

  R24: legacyResource(EndPoint + 'activity-sum-report'),

  R25: legacyResource(EndPoint + 'relatorio/gerar-r25'),

  R26: legacyResource(EndPoint + 'on-call-spreadsheet'),

  BetaR26: legacyResource(EndPoint + 'relatorio/gerar-r26'),

  R27: legacyResource(EndPoint + 'absent-report'),

  BetaR27: legacyResource(EndPoint + 'relatorio/gerar-r27'),

  R28: legacyResource(EndPoint + 'whbcloser-report'),

  BetaR28: legacyResource(EndPoint + 'relatorio/gerar-r28'),

  R29: legacyResource(EndPoint + 'whb-management-report'),

  BetaR29: legacyResource(EndPoint + 'relatorio/gerar-r29'),

  R30: legacyResource(EndPoint + 'whb-daily-tracking-report'),
  BetaR30: legacyResource(EndPoint + 'relatorio/gerar-r30'),

  R31: legacyResource(EndPoint + 'relatorio/gerar-r31'),

  R32: legacyResource(EndPoint + 'situation-report'),

  R33: legacyResource(EndPoint + 'manager-report'),

  R35: legacyResource(EndPoint + 'acompanhamento-de-funcionarios-report'),

  R36: legacyResource(EndPoint + 'relatorio-movimentacao-jornadas-escalas'),

  BetaR36: legacyResource(EndPoint + 'relatorio/gerar-r36'),

  R37: legacyResource(EndPoint + 'relatorio/gerar-r37'),

  RelatorioDePontosConsiderados: legacyResource(EndPoint + 'relatorio/gerar-relatorio-de-pontos-considerados'),

  R07: legacyResource(EndPoint + 'relatorio/gerar-relatorio-de-movimentaoces-dos-empregados'),

  relatorioDeBaixasAgendadas: legacyResource(EndPoint + 'relatorio/gerar-relatorio-de-baixas-agendadas'),

  relatorioAuditoria: legacyResource(EndPoint + 'relatorio/gerar-auditoria'),

  E01: legacyResource(EndPoint.replace('/api', '') + 'export_script_ponto_compman'),

  BetaE01: legacyResource(EndPoint + 'relatorio/exportador/gerar-e01'),

  E02: legacyResource(EndPoint.replace('/api', '') + 'export_script_apontamento_compman'),

  BetaE02: legacyResource(EndPoint + 'relatorio/exportador/gerar-e02'),

  E03: legacyResource(EndPoint + 'export_whbe'),
  BetaE03: legacyResource(EndPoint + 'relatorio/exportador/gerar-e03'),

  E04: legacyResource(EndPoint + 'audio-extractor'),

  E05: legacyResource(EndPoint + 'export_adf'),

  E05_671: legacyResource(EndPoint + 'relatorio/exportador/gerar-e05/portaria-671'),

  E06: legacyResource(EndPoint + 'relatorio/exportador/gerar-e06'),

  E07: legacyResource(EndPoint + 'relatorio/exportador/gerar-e07'),

  E08: legacyResource(EndPoint.replace('/api', '') + 'export_script_justify_compman'),

  E09: legacyResource(EndPoint.replace('/api', '') + 'export_e09'),

  BetaE09: legacyResource(EndPoint + 'relatorio/exportador/gerar-e09'),

  E10: legacyResource(EndPoint + 'relatorio/exportador/gerar-e10'),

  E11: legacyResource(EndPoint + 'relatorio/exportador/gerar-e11'),

  E12: legacyResource(EndPoint + 'relatorio/exportador/gerar-e12'),

  E13: legacyResource(EndPoint + 'relatorio/exportador/gerar-e13'),

  I01: legacyResource(EndPoint + 'import-afd{/forceKind}'),

  I01Beta: legacyResource(EndPoint + 'importador-afd-gestao'),

  I02: legacyResource(EndPoint + 'import-escalas'),

  I03: legacyResource(EndPoint + 'importar_sobreaviso'),

  I05: legacyResource(EndPointImportadoresGestao),

  ImportadorEscalaTemporaria: legacyResource(EndPointImportadoresGestao),

  I06: legacyResource(EndPoint + 'importador-bh-gestao-web'),

  ArquivosDeImportadores: legacyResource(EndPointArquivosDeImportadores + '{/tipoDeImportador}{/tipoDeArquivo}'),

  EmpregadosPonto: legacyResource(EndPoint + 'relatorio/gerar-empregados-batendo-ponto'),

  RelatorioFaltas: legacyResource(EndPoint + 'relatorio/gerar-relatorio-de-faltas'),

  acompanhamentoDiarioGeral: legacyResource(EndPoint + 'acompanhamento-diario/geral'),

  cadastrarLimiteDeHoraExtras: legacyResource(EndPoint + 'acompanhamento-diario{/idEmpregado}{/ano}{/mes}{/dia}'),

  R38: legacyResource(EndPoint + 'relatorio/gerar-template-de-espelho'),

  RelatorioSolicitacaoHorasExtras: legacyResource(EndPoint + 'relatorio/gerar-relatorio-de-solicitacoes-de-horas-extras'),

  uploadFile: async (bucket, file, filename) => {
    const formData = new FormData()
    formData.append('file', file)

    const result = await legacyResource(`${EndPoint}upload-file-to-bucket/${bucket}/${filename}`)
      .save(formData)
    return result
  },

  obterUrlAssinadaParaUploadDeArquivo: async (nomeDoBucket, tipoDoArquivo, idEmpregado, ano, mes, dia, nomeDoArquivo) => {
    const urlAssinadaParaUpload = await legacyResource(`${EndPoint}gerar-url-assinada-para-upload-de-arquivo-no-bucket`)
      .save({
        bucket: nomeDoBucket,
        tipo_de_arquivo: tipoDoArquivo,
        empregado: idEmpregado,
        ano: ano,
        mes: mes,
        dia: dia,
        nome_do_arquivo: nomeDoArquivo
      })
    return urlAssinadaParaUpload.body.success
  },

  obterUrlAssinadaParaUploadDePlanilhaDeSelecao: legacyResource(
    config.baseFastApiUrl + "/relatorios/gerar-url-upload-planilha-selecao",
    {},
    {
      post: { method: 'POST' },
    }  
  ),

  resolverPlanilhaDeSelecao: legacyResource(
    config.baseFastApiUrl + "/relatorios/resolver-selecao-por-planilha",
    {},
    {
      post: { method: 'POST' },
    }  
  ),

  uploadDoArquivo: async (urlAssinada, arquivo) => {
    const respostaDoUploadDoArquivoParaOBucket = await fetch(urlAssinada, {
      method: 'PUT',
      body: arquivo,
      headers: {
        'Content-Type': 'application/octet-stream'
      }
    }).then(function (respostaDoUploadDoArquivoParaOBucket) {
      return respostaDoUploadDoArquivoParaOBucket
    }).catch(erro => {
      this.$modalDeErro(erro)
    })
    return respostaDoUploadDoArquivoParaOBucket
  },

  consultaIp: legacyResource('https://us-central1-pontotel-tools.cloudfunctions.net/consultar-ip'),

  consultarFilaDeRelatorios: legacyResource(EndPoint + 'relatorio/fila'),
  cancelarGeracaoDeRelatorio: legacyResource(EndPoint + 'relatorio/cancelar'),

  consultarTamanhoCLiente: legacyResource('https://us-central1-pontotel-tools.cloudfunctions.net/consultador-de-tamanho-do-cliente-no-auth'),

  integrarVerbasFaltas: legacyResource(EndPoint + 'integracao/recalcular-e-iniciar'),
  acompanhamentoIntegracao: legacyResource(EndPointIntegracao + 'acompanhamento/verbas-faltas/status'),
  novasIntegracoesSankhyaAtivas: legacyResource(EndPointIntegracao + 'integracao/calendario-de-etapa/visualizacao-de-entidades'),

  listarDocumentosCadastroEmpregador: legacyResource(EndPoint + 'listar-documentos-do-empregador-por-pais'),
  listarDocumentosCadastroEmpregado: legacyResource(EndPoint + 'listar-documentos-do-empregado-por-pais'),
  supervisor: legacyResource(EndPoint + 'supervisor{/id}'),

  gerarLogLoginSSO: legacyResource(EndPoint + 'salvar-log-usuario-logou'),

  obterTokenDoKeycloakAPartirDaSessao: async (realm, codigo, sessao, redirectUri) => {
    const result = await legacyHttp.post(`${EndPointKeycloak}realms/${realm}/protocol/openid-connect/token`, {
      grant_type: 'authorization_code',
      client_id: 'pontotel',
      session_state: sessao,
      code: codigo,
      redirect_uri: redirectUri
    }, {
      emulateJSON: true
    })
    return result
  },

  obterAmbienteDoUsuario: async (email) => {
    const result = await legacyHttp.get(`${EndPoint}ambientes-do-usuario/${email}`, {})
    return result
  },

  listarDDDeFusosHorarios: legacyResource(EndPoint + `company/listar-ddds`)
}
export const mixins = {
  methods: {
    $dispatchUseState: (useState, payload) => store.dispatch(useState, payload),
    $commitUseState: (useState, payload) => store.commit(useState, payload)
  }
}

export const installLegacyServices = (app) => {
  app.mixin(mixins)
  app.config.globalProperties.$API = API
  app.config.globalProperties.$hasPermission = hasPermission
  app.config.globalProperties.$uiv_notify = Notification.notify
  app.config.globalProperties.$checkUserFiles = function (relatorioInfo = {}) {
    emitCheckUserFiles(relatorioInfo)
  }
}
